function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.288,473.07V111.068h143.125c-0.007-2.457-0.024-4.877-0.042-7.271 c-0.052-7.056-0.101-13.721,0.13-20.479l0.018-0.528c0.222-6.579,0.452-13.381,2.113-19.82 c3.819-14.808,15.208-23.708,30.462-23.809c16.57-0.108,38.451-0.232,60.763-0.232c19.238,0,36.615,0.09,53.125,0.274 c20.719,0.232,36.022,16.245,36.394,38.075c0.133,7.947,0.1,15.766,0.065,24.044c-0.014,3.104-0.025,6.238-0.03,9.418h143.302 v362.33H21.288z M469.31,451.409V132.7H42.619v318.709H469.31z M325.873,110.56c0.034-0.294,0.056-0.54,0.056-0.763 c0.003-2.967,0.02-5.936,0.033-8.903c0.037-7.356,0.076-14.962-0.075-22.426c-0.226-11.194-7.072-17.891-18.315-17.913 c-17.083-0.033-34.165-0.046-51.246-0.046c-18.585,0-37.169,0.016-55.753,0.041c-9.392,0.013-13.629,3.66-14.167,12.195 c-0.574,9.101-0.448,18.071-0.314,27.568c0.047,3.352,0.096,6.801,0.109,10.248L325.873,110.56L325.873,110.56z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M218.506,401.271V329.85h-71.759v-75.153h71.424v-71.76h75.152v71.423h71.76v75.153H293.66v71.76H218.506 L218.506,401.271z M272.273,379.645v-71.522h71.229v-32.279h-71.67v-71.377h-32.279v71.623h-71.327v32.277h71.771v71.278H272.273 L272.273,379.645z"
})));

var SvgMyBenefits = function SvgMyBenefits(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyBenefits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/myBenefits.23b22aae.svg";
export { ForwardRef as ReactComponent };